module.exports = __webpack_public_path__ + "img/NICE-Accredited-Logo.8d6783b2.jpg";